import {useEffect} from "react";
import {isKeyboardAdded, keyPressed, keyReleased, keyboardAdded, keyboardRemoved} from "../providers/KeyboardProvider";

export default function useKeyboard(onKeyDown, onKeyUp = ()=>{}) {  

  useEffect(()=>{     
    if (!isKeyboardAdded()) {

      const handleKeyDown = (e) => {
        const {key} = e;
        keyPressed(key);
        onKeyDown(key);
      }
    
      const handleKeyUp = (e) => {
        const {key} = e;        
        keyReleased(key);
        onKeyUp(key);
      }
          
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      
      keyboardAdded();
      // console.log('[useKeyboard Effect] Keyboard Events Added');    

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup', handleKeyUp);
        keyboardRemoved();
        // console.log('[useKeyboard Effect] Keyboard Events Removed');
      }
    }
  }, [onKeyDown, onKeyUp]);

  return {
    pressedKeys:keyPressed
  }
}
